import React from 'react';
import cx from 'classnames';
import MetisMenu from 'react-metismenu';
import { Link } from 'react-router-dom';
import LinkComponentWithNotificationFlag from '../../../LinkComponentWithNotificationFlag/LinkComponentWithNotificationFlag';
import { Event, gtmEvent } from '../../../Tracking/index';

export interface NavContentItem {
    icon: string;
    label: React.ReactNode;
    to?: string;
    isVisible?: boolean;
    isDisabled?: boolean;
    perCode?: string[];
    notificationFlagCode?: string;
    classNameItem?: string;
}

export interface LeftMenuItemProps {
    icon: string;
    label: React.ReactNode;
    to?: string;
    flagCode?: string;
    className?: string;
    marginLeft?: number;
    stateIcon?: string;
    trackingAction?: string;
    gtmCategory?: string;
    onClickExtra?: () => void;
    content?: NavContentItem[];
    forceReload?: boolean;
}

const DEFAULT_CLASSNAME = 'app-sidebar__heading vertical-nav-menu';

export const LeftMenuItem = (props: LeftMenuItemProps) => {
    const {
        icon,
        label,
        to,
        flagCode,
        className = DEFAULT_CLASSNAME,
        marginLeft = -10,
        stateIcon = 'pe-7s-angle-down',
        trackingAction,
        gtmCategory = 'MenuBar',
        onClickExtra,
        content,
        forceReload,
    } = props;

    const menuContent: NavContentItem[] = content ?? [
        {
            icon,
            label,
            to,
            isVisible: true,
            isDisabled: false,
            perCode: [],
            notificationFlagCode: flagCode,
        },
    ];

    const handleSelected = () => {
        Event(
            'MenuBar',
            trackingAction ?? (typeof label === 'string' ? label : ''),
            'LEFT_MENU'
        );
        gtmEvent(gtmCategory);
        onClickExtra?.();
    };

    const linkComponent = flagCode
        ? (params: any) => (
              <LinkComponentWithNotificationFlag
                  {...params}
                  icon={icon}
                  flagCode={flagCode}
                  forceReload={forceReload}
              />
          )
        : (params: any) => (
              <Link
                  to={params.to}
                  className={cx(
                      params.className,
                      params.active && params.classNameActive
                  )}
                  onClick={
                      forceReload
                          ? () => {
                                window.location.href = params.to;
                            }
                          : undefined
                  }>
                  {params.children}
              </Link>
          );

    return (
        <MetisMenu
            content={menuContent}
            activeLinkFromLocation
            className={className}
            style={{ marginLeft: `${marginLeft}px` }}
            iconNamePrefix=""
            classNameStateIcon={stateIcon}
            onSelected={handleSelected}
            toggle="false"
            LinkComponent={linkComponent}
        />
    );
};
